import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { site } from "../generated/content";

/**
 * Firebase always serves the site from bdc-mimarlik.web.app and
 * bdc-mimarlik.firebaseapp.com as well as the real domain, and those two
 * cannot be turned off. Without a canonical tag a search engine sees the same
 * pages on three hosts, treats them as duplicates and splits the ranking
 * between them.
 *
 * This points every page at its address on the real domain, whichever host
 * actually served it.
 */
export default function CanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    const origin = (site.siteUrl || "").replace(/\/+$/, "");
    if (!origin) return;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = origin + pathname;

    // og:url follows the same rule, so shares carry the real address.
    let og = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:url");
      document.head.appendChild(og);
    }
    og.content = origin + pathname;
  }, [pathname]);

  return null;
}
